import { DateTime } from "luxon";

export default function parseMarkdown (input, values = {}) {
  const { activeQuestionCount, questionBankName } = values;
  const subbedString = input.replace(/(%{qb})/g, questionBankName).replace(/(%{year})/g, DateTime.now().year).replace(/(%{active_question_count})/g, activeQuestionCount);
  return subbedString;
}
